import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { TabScreens } from '../../../routes';

export const AdminTabSvg: React.FC = () => {
  const currentTabScreen = useSelector(
    (state: RootState) => state.tabSlice.screen
  );

  // Color based on active tab
  const fillColor = currentTabScreen === TabScreens.Admin ? 'var(--main-turquoise)' : 'var(--text-color)';
  const strokeColor = fillColor;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={24}
      height={24}
      fill="none"
    >
      <path
        d="M24.1,13H7.9c-1.2,0-2.3-0.6-3-1.6L4,10l12-6l12,6l-0.9,1.4C26.4,12.4,25.3,13,24.1,13z"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.8,17.8c-0.6-0.7-1.2-1-1.8-0.8c-0.9,0.4-1.2,2-0.7,3.6c0.5,1.6,1.7,2.7,2.6,2.3c0,0,0.1,0,0.1-0.1
        c0.8,3.5,3.6,6.1,7,6.1s6.3-2.6,7-6.1c0,0,0.1,0.1,0.1,0.1c0.9,0.4,2.1-0.7,2.6-2.3C26.3,19,26,17.4,25,17c-0.6-0.2-1.3,0.1-1.8,0.8"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M21.8,18H10.2C8.5,18,7,16.5,7,14.8V13h18v1.8C25,16.5,23.5,18,21.8,18z"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </svg>
  );
};
